const state = {

    user_name: null,
    user_systems: [],
    user_system_levels:{

    }
}

// getters
const getters = {

}

const actions = {
    setupState({state,commit}, newState){
        commit('setupState',newState)
    },
    updateSingleUserSystemLevel({state,commit}, newUserSystemLevelObj){
        commit('updateSingleUserSystemLevel',newUserSystemLevelObj)
    }
}

const mutations = {
    setupState(state,newState){
        state.user_name = newState.user_name;
        state.user_systems = newState.user_systems;
        state.user_system_levels = newState.user_system_levels;
    },
    updateSingleUserSystemLevel(state,newUserSystemLevelObj){

        var target_subsystem_name = newUserSystemLevelObj.name;
        var target_subsystem_level = parseInt( newUserSystemLevelObj.level );
        
        if(target_subsystem_level > -1){
            //add this user_systems and user_system_levels (if not already exist)
            if( state.user_systems.indexOf(target_subsystem_name) > -1){
                //already exist,do nothing
            }else{
                state.user_systems.push(target_subsystem_name)
            }    
            //update user_system_levels
            state.user_system_levels[target_subsystem_name] = target_subsystem_level

        }else{
            //remove this user_systems and user_system_levels (if exist)
            if( state.user_systems.indexOf(target_subsystem_name) > -1){
                let idx = state.user_systems.indexOf(target_subsystem_name)
                state.user_systems.splice(idx,1);
            }       
            if(state.user_system_levels[target_subsystem_name] >= 0){
                delete state.user_system_levels[target_subsystem_name];
            }

            
        }
    }
    
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations    
}


// WEBPACK FOOTER //
// ./src/store/modules/userSystemLevels.js